import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { moveFocusTo } from './helperFunctions/Accessibility';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location !== prevProps.location) {
      window.scrollTo(0, 0);
      moveFocusTo('body');
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

export default withRouter(ScrollToTop);
